class ProductRangeTooltip extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.buttonEl = this.querySelector(
      '[data-product-range-tooltip-el="button"]',
    )

    this.measureButtonPosition()
  }

  setupListeners () {
    super.setupListeners()

    // Throttle resize handler for better performance
    const { debounce } = window.BAO.Utils
    this.debouncedMeasureButtonPosition = debounce(this.measureButtonPosition.bind(this), 150)
    window.addEventListener('resize', this.debouncedMeasureButtonPosition, { passive: true })
  }

  measureButtonPosition () {
    this.resetPositionClasses()

    const result = this.checkElementPosition(this.buttonEl)
    if (!result.isInViewport) {
      if (result.position === 'left') {
        this.buttonEl.classList.add('prd-Card_LabelTooltipButton-left')
      }
      if (result.position === 'right') {
        this.buttonEl.classList.add('prd-Card_LabelTooltipButton-right')
      }
    }
  }

  checkElementPosition (el) {
    const rect = el.getBoundingClientRect()

    const isInViewport =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    if (isInViewport) {
      return { isInViewport: true, position: 'inside' }
    } else {
      let position = ''
      if (
        rect.right > (window.innerWidth || document.documentElement.clientWidth)
      ) {
        position = 'right'
      } else if (rect.left < 0) {
        position = 'left'
      } else if (rect.top < 0) {
        position = 'top'
      } else if (
        rect.bottom >
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        position = 'bottom'
      }
      return { isInViewport: false, position }
    }
  }

  resetPositionClasses () {
    this.buttonEl.classList.remove(
      'prd-Card_LabelTooltipButton-left',
      'prd-Card_LabelTooltipButton-right',
    )
  }
}

if (!customElements.get('product-range-tooltip')) {
  customElements.define('product-range-tooltip', ProductRangeTooltip)
}
